import { render, staticRenderFns } from "./TabelaFuncionarios.vue?vue&type=template&id=53643ce1&scoped=true"
import script from "./TabelaFuncionarios.vue?vue&type=script&lang=js"
export * from "./TabelaFuncionarios.vue?vue&type=script&lang=js"
import style0 from "./TabelaFuncionarios.vue?vue&type=style&index=0&id=53643ce1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53643ce1",
  null
  
)

export default component.exports